import { useUserStore } from '~/stores/userStore'
import { hasLoginEventCookie, pushHemValueToDataLayer } from '~/services/hemValueService'

/**
 * Pushes {@code hem_value} after Auth0 login/register when Thorne sets loginEvent=true.
 * Independent of Hightouch and the GTM store.
 */
export default defineNuxtPlugin({
  name: 'hem-value-datalayer',
  setup(nuxtApp) {
    const router = useRouter()
    let isProcessingLoginEvent = false
    let hasPushedForCurrentLoginEvent = false

    const pushHemValueAfterLogin = async () => {
      if (!hasLoginEventCookie()) {
        hasPushedForCurrentLoginEvent = false
        return
      }

      if (isProcessingLoginEvent || hasPushedForCurrentLoginEvent) return

      const userStore = useUserStore()
      isProcessingLoginEvent = true

      try {
        await userStore.fetch()

        const email = userStore.data?.username
        if (!email) return

        await pushHemValueToDataLayer(email)
        hasPushedForCurrentLoginEvent = true
      } catch (error) {
        console.warn('Failed to push hem_value after login', error)
      } finally {
        isProcessingLoginEvent = false
      }
    }

    nuxtApp.hook('app:mounted', () => {
      pushHemValueAfterLogin()
    })

    router.afterEach(() => {
      pushHemValueAfterLogin()
    })
  }
})
